export function getAuctionPreviewLink(auctionId) {
  return `/auctions-management/details/${auctionId}`;
}

export function getTransportOrderPreviewLink(transportOrderid) {
  return `/transport-orders-management/preview/${transportOrderid}`;
}
